<template>
	<v-card class="pa-2">
		<div v-if="isSummery">
			<div v-if="!items.length" class="red--text">
				تاکنون اعتبارسنجی انجام نشده است
			</div>
			<div v-else>
				<div style="border: 1px solid #ededed;background: #f7f7f7;" class="d-flex justify-space-between pa-2" v-for="item in items" :key="item.id">
					<div class="d-flex flex-column justify-center align-center">
						<v-avatar color="secondary" x-large>
							<div>
								<div v-if="!item.gradeNumber" style="text-align: center;font-size: 10px;color: #fff;">رتبه</div>
								<div class="white--text">{{ item.result || '-' }}</div>
								<div class="white--text">{{ item.gradeNumber || '' }}</div>
							</div>
						</v-avatar>
					</div>
					<div class="d-flex flex-column justify-center" style="flex-grow: 2;padding: 5px;">
						<div class="d-flex"><span class="grey--text">{{ item.date_Persian.date }}</span></div>
						<div class="d-flex"><span>وضعیت: {{ item.status_Str }}</span></div>
					</div>
				</div>
			</div>
			<div class="mt-2">
				<v-btn @click="showIranValidityManager">
					مدیریت اعتبارسنجی ها
				</v-btn>
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length" class="red--text">
				تاکنون اعتبارسنجی انجام نشده است
			</div>
			<div>
				<v-row class="text-center my-3" style="border-bottom: 1px dashed #ccc;">
					<v-col cols="12" class="pa-1">اعتبار کیف پول:</v-col>
					<v-col cols="12" class="grey--text pa-1 mx-1">{{ String(userCredit).toPriceFormat() }} تومان</v-col>
					<v-col cols="12" class="pa-1">
						<v-btn class="mx-1" color="info" small @click="addWalletCreditCharge" v-if="!isAdmin && !isAgent">
							<v-icon>mdi-currency-usd</v-icon>
							افزایش اعتبار
						</v-btn>
					</v-col>
				</v-row>
				<div v-for="item in items" :key="item.id" class="d-flex my-2" style="border: 1px solid #ededed;background: #f7f7f7;">
					<div style="width:100%" class="text-center " v-if="item.status === 1">
						<v-text-field style="width:200px; display: inline-block;" v-model="item.otp" label="کد مجوز" persistent-hint hint="لطفا کد مجوز پیامک شده را وارد کنید" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد مجوز را وارد کنید']" required />
						<v-btn small class="mr-2" color="primary" :loading="loading" @click="submitOtp(item)">ثبت کد</v-btn>
						<v-btn small outlined class="mr-2" color="primary" :loading="loading" @click="renewOtp(item)">ارسال مجدد</v-btn>
					</div>
					<div class="d-flex" style="width:100%" v-else>
						<div class="d-flex flex-column justify-center align-center">
							<v-avatar color="secondary" x-large>
								<div>
									<div v-if="!item.gradeNumber" style="text-align: center;font-size: 10px;color: #fff;">رتبه</div>
									<div class="white--text">{{ item.result || '-' }}</div>
									<div class="white--text">{{ item.gradeNumber || '' }}</div>
								</div>
							</v-avatar>
							<v-btn color="secondary" x-small text @click="editGradeMode = true" v-if="isAdmin && !editGradeMode">ویرایش رتبه</v-btn>
							<div class="d-flex flex-column justify-center align-center" style="width: 100px;" v-if="isAdmin && editGradeMode">
								<v-select hide-details compact v-model="item.result" :items="grades" item-text="title" item-value="value" label="انتخاب کنید"></v-select>
								<v-text-field style="width:75px; display: inline-block;" v-model="item.gradeNumber" label="رقم امتیاز" required />
								<v-btn :loading="saveGradeLoading == item.id" class="my-1" color="success" prepend-icon="mdi-check" elevation="0" dark x-small @click="saveGrade(item)">
									ذخیره
								</v-btn>
							</div>
						</div>
						<div class="d-flex flex-column justify-center" style="flex-grow: 2; border-left: 1px dashed #ccc;padding: 5px;">
							<div class="d-flex"><span class="grey--text">{{ item.date_Persian.date }}</span></div>
							<div class="d-flex"><span>{{ item.status_Str }}</span></div>
							<div class="d-flex" v-if="item.messages"><v-icon x-small color="error">mdi-alert-circle-outline</v-icon><span class="error--text">پیام ها: {{ item.messages }}</span></div>
						</div>
						<div class="px-2 d-flex flex-column justify-center">
							<v-btn small outlined color="secondary" v-if="item.status === 2 || (item.status === 4 && !item.reportPdfFileName)" href="#" @click="getStatus(item.id)" :loading="loading">دریافت نتیجه</v-btn>
							<a v-if="item.url" :href="item.url" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">مشاهده گزارش</a>
							<a v-if="item.reportPdfFileName" :href="`/IranValidity/DownloadPdf/${item.id}`" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">دریافت pdf</a>
						</div>
					</div>
				</div>
			</div>
			<div class="py-2 mt-2 text-center">
				<v-btn @click="add" color="secondary" :loading="submitNewValidityloading">
					ثبت درخواست اعتبارسنجی جدید
					<br />
					(هزینه {{ String(iranValidityPrice).toPriceFormat() }} تومان)
				</v-btn>
			</div>

		</div>
		<v-dialog v-model="dialogWalletCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ کیف پول</span></div>
					<v-spacer />
					<v-btn @click="dialogWalletCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<WalletCreditCharge ref="walletCreditCharge" v-if="dialogWalletCreditCharge" @callbck="callbck_walletCreditCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogIranValidityManager" scrollable persistent max-width="800px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت اعتبارسنجی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogIranValidityManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<IranValidityManager v-if="dialogIranValidityManager" @callbck="callbck_iranValidityManager" :isAdmin="false" :isAgent="false" :isSummery="false" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
import api from '@/util/app-api'
import { get } from 'vuex-pathify'
import toast from '@/util/toast'

export default {
	name: 'IranValidityManager',
	props: {
		userId: { type: Number, default: 0 },
		isAdmin: Boolean,
		isAgent: Boolean,
		isSummery: Boolean,
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		WalletCreditCharge: () => import('@/components/forms/WalletCreditCharge'),
		IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
	},
	data() {
		return {
			saveGradeLoading: '',
			items: [],
			userCredit: 0,
			dialogWalletCreditCharge: false,
			dialogIranValidityManager: false,
			editGradeMode: false,
			loading: false,
			submitNewValidityloading: false,
			grades: [
				{ value: 'فاقد رتبه', title: 'فاقد رتبه' },
				{ value: 'A', title: 'A' },
				{ value: 'A1', title: 'A1' },
				{ value: 'A2', title: 'A2' },
				{ value: 'A3', title: 'A3' },
				{ value: 'B', title: 'B' },
				{ value: 'B1', title: 'B1' },
				{ value: 'B2', title: 'B2' },
				{ value: 'B3', title: 'B3' },
				{ value: 'C', title: 'C' },
				{ value: 'C1', title: 'C1' },
				{ value: 'C2', title: 'C2' },
				{ value: 'C3', title: 'C3' },
				{ value: 'D', title: 'D' },
				{ value: 'D1', title: 'D1' },
				{ value: 'D2', title: 'D2' },
				{ value: 'D3', title: 'D3' },
				{ value: 'E', title: 'E' },
				{ value: 'E1', title: 'E1' },
				{ value: 'E2', title: 'E2' },
				{ value: 'E3', title: 'E3' },
				{ value: 'F', title: 'F' },
				{ value: 'F1', title: 'F1' },
				{ value: 'F2', title: 'F2' },
				{ value: 'F3', title: 'F3' },
			]
		}
	},
	computed: {
		...get('appSettings', {
			adminIranValidityPrice: 'iranValidityPrice',
		}),
		...get('agentAppSettings', {
			agentIranValidityPrice: 'iranValidityPrice',
		}),
		...get('memberAppSettings', {
			memberIranValidityPrice: 'iranValidityPrice',
		}),
		iranValidityPrice() {
			return this.isAdmin ? this.adminIranValidityPrice : this.isAgent ? this.agentIranValidityPrice : this.memberIranValidityPrice
		}
	},
	mounted() {
		this.loadData()
		if (!this.isSummery)
			this.loadUserCredit()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('member/IranValidityReport/ListByMemberId/' + this.userId, null)
				.then(
					response => {
						this.items = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		loadUserCredit() {
			api.get('member/User/loadUserCredit/' + (this.userId ? this.userId : ''), null)
				.then(response => {
					this.userCredit = response
				})
				.catch(err => {
				})
				.finally(x => {
				})
		},
		update(updatedVal) {
			if (!updatedVal)
				return
			let index = this.patterns.findIndex(x => x.id === updatedVal.id)
			if (index > -1) {
				this.patterns[index] = updatedVal
				this.$emit('itemsUpdated', this.patterns)
			}
		},
		async add() {
			if (this.userCredit < this.iranValidityPrice) {
				toast.error('اعتبار کیف پول شما جهت اعتبارسنجی کافی نمی باشد.')
				return
			}
			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از ثبت درخواست اعتبارسنجی مطمئن هستید؟ با تایید این فرم در  صورت موفقیت آمیز بودن عملیات، هزینه عملیات از کیف پول شما کسر خواهد شد.',
			)) {
				this.submitNewValidityloading = true
				api.post('member/IranValidityReport/Create/' + (this.userId ? this.userId : ''))
					.then(
						response => {
							toast.success('درخواست با موفقیت ثبت شد.')
							this.loadData()
							this.loadUserCredit()
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(f => {
						this.submitNewValidityloading = false
					})
			}
		},
		submitOtp(item) {
			this.loading = true
			api.post('member/IranValidityReport/SubmitOTP/' + item.id + '/' + item.otp)
				.then(response => {
					toast.success('درخواست با موفقیت ثبت شد.')
					this.loadData()
					this.loadUserCredit()
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		renewOtp(item) {
			this.loading = true
			api.post('member/IranValidityReport/RenewOTP/' + item.id)
				.then(response => {
					toast.success('درخواست با موفقیت ثبت شد.')
					this.loadData()
					this.loadUserCredit()
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		async getStatus(id) {
			if (!id) { return }
			this.loading = true
			api.get('member/IranValidityReport/GetStatus/' + id)
				.then(response => {
					this.loadData()
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.loading = false
				})
		},
		callbck_walletCreditCharge() {
			this.dialogWalletCreditCharge = false
		},
		addWalletCreditCharge() {
			this.dialogWalletCreditCharge = true
		},
		callbck_iranValidityCharge() {
			this.dialogIranValidityManager = false
		},
		showIranValidityManager() {
			this.dialogIranValidityManager = true
		},
		callbck_iranValidityManager() {

		},
		saveGrade(item) {
			this.saveGradeLoading = item.id
			api.post('admin/IranValidityReport/SetGrade/', { reportId: item.id, grade: item.result, gradeNumber: item.gradeNumber })
				.then(
					response => {
						toast.success('رتبه با موفقیت ثبت شد.')
						this.loadData()
						this.editGradeMode = false
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.saveGradeLoading = ''
				})
		}
	}
}
</script>
<style scoped>
.pattern-tags {
	list-style: none;
}

.pattern-tags li {
	display: inline;
	margin: 3px;
	color: blueviolet;
}

.link {
	text-decoration: none;
	font-size: 11px;
	padding: 3px;
	border-radius: 5px;
	border: 1px solid grey;
	margin-bottom: 3px;
	text-align: center;
}
</style>
